<div *ngIf="isLoading" class="card-loading-shell">
  <div class="card-skeleton">
    <div class="skeleton-block skeleton-banner"></div>
    <div class="skeleton-block skeleton-avatar"></div>
    <div class="skeleton-action-bar">
      <div class="skeleton-block skeleton-action"></div>
      <div class="skeleton-block skeleton-action"></div>
    </div>
    <div class="skeleton-body">
      <div class="skeleton-block skeleton-title"></div>
      <div class="skeleton-block skeleton-text skeleton-text-wide"></div>
      <div class="skeleton-round-row">
        <div class="skeleton-block skeleton-round"></div>
        <div class="skeleton-block skeleton-round"></div>
        <div class="skeleton-block skeleton-round"></div>
      </div>
      <div class="skeleton-block skeleton-button-line"></div>
      <div class="skeleton-block skeleton-button-line skeleton-button-short"></div>
      <div class="skeleton-block skeleton-text"></div>
      <div class="skeleton-block skeleton-text skeleton-text-mid"></div>
    </div>
  </div>
</div>

<div *ngIf="!isLoading && loadError" class="card-loading-shell">
  <div class="card-loading-panel">
    <i class="fas fa-exclamation-circle text-danger mb-3" style="font-size: 2rem;"></i>
    <h5>No se pudo cargar</h5>
    <p>{{ loadError }}</p>
  </div>
</div>

<div *ngIf="isExpired"
  class="expired-container d-flex flex-column align-items-center justify-content-center vh-100 text-center"
  style="background-color: #f8f9fa;">
  <div class="card shadow p-4 mx-3 rounded" style="max-width: 400px;">
    <i class="fas fa-lock text-danger mb-3" style="font-size: 3rem;"></i>
    <h3 class="fw-bold text-dark">Tarjeta Vencida</h3>
    <p class="text-muted mt-2">
      Esta tarjeta digital ha superado su fecha de expiración y ya no se encuentra disponible públicamente.
    </p>
    <p class="text-muted mb-4">
      Por favor, contáctese con el soporte para renovar su suscripción y volver a activarla.
    </p>
    <a href="https://wa.me/56992190784" target="_blank" class="btn btn-success btn-lg w-100 fw-bold rounded-pill">
      <i class="fab fa-whatsapp me-2"></i> Contactar
    </a>
  </div>
</div>

<div class="container text-center p-0" style="padding-bottom: 0 !important;" *ngIf="!isLoading && tarjeta && profile && !isExpired">

  <div class="card mx-auto shadow-lg" style="max-width: 600px; border-radius: 15px;"
    [ngStyle]="{'background-color': profile?.backgroundColor || '#FFFFFF'}">


    <div [ngClass]="'card-img-top banner image-shell' " *ngIf="profile?.showLogo"
      [ngStyle]="{'max-width': '600px', 'height': profile?.logoHeight + 'px', 'text-align': 'left'}">

      <div class="image-skeleton logo-skeleton" *ngIf="!logoLoaded"></div>
      <img [src]="profile?.imgLogo" [class.image-hidden]="!logoLoaded"
        (load)="markImageLoaded('logo')" (error)="markImageLoaded('logo')"
        [ngStyle]="{'max-height': profile?.logoHeight + 'px', 'margin-left': '20px'}">
    </div>
    <div class="position-relative">
      <div class="image-skeleton banner-skeleton" *ngIf="!bannerLoaded"
        [ngStyle]="{height: profile?.bannerHeight + 'px'}"></div>
      <img [src]="profile?.imgBanner" [class.image-hidden]="!bannerLoaded"
        (load)="markImageLoaded('banner')" (error)="markImageLoaded('banner')" [ngStyle]="profile?.showLogo
              ? {
                  height: profile?.bannerHeight + 'px',
                  'width': '100%'
                }
              : {
                  height: profile?.bannerHeight + 'px',
                  'border-top-left-radius': '15px',
                  'border-top-right-radius': '15px',
                  'width': '100%'
                }" />

      <!-- Notification Bell -->
      <div class="notification-icon" (click)="toggleNotificationsPanel()" *ngIf="profile">
        <i class="fas fa-bell"></i>
        <span class="notification-badge" *ngIf="unreadCount > 0">
          {{ unreadCount }}
        </span>
      </div>

      <div class="image-skeleton profile-img profile-img-skeleton" *ngIf="!profileImageLoaded"
        [ngStyle]="{ top: (profile?.bannerHeight - 40) + 'px' }"></div>
      <img [src]="tarjeta?.imgProfile" class="profile-img" [class.image-hidden]="!profileImageLoaded"
        (load)="markImageLoaded('profile')" (error)="markImageLoaded('profile')"
        [ngStyle]="{ top: (profile?.bannerHeight - 40) + 'px' }">

    </div>

    <div class="action-bar" [ngStyle]="{'background-color': profile?.buttonColor, 'color': profile?.letterColor}">
      <button class="btn-action" [ngStyle]="{'background-color': profile?.buttonColor, 'color': profile?.letterColor}"
        (click)="compartir()">
        <i class="fas fa-share-alt"></i> Compartir
      </button>

      <button *ngIf="profile?.showSave" class="btn-action"
        [ngStyle]="{'background-color': profile?.buttonColor, 'color': profile?.letterColor}" (click)="descargarVCF()">
        Guardar <i class="fas fa-download"></i>
      </button>

      <a *ngIf="!profile?.showSave && profile?.showFooterTienda" class="btn-action" [ngStyle]="{
              'background-color': profile?.buttonColor,
              'color': profile?.letterColor,
              'text-decoration': 'none',
              'margin-right' : '5px'
            }" [href]="'https://backend.v6card.com/cardToPdf/' + tarjeta?.uid" target="_blank">
        Descargar PDF <i class="fas fa-download"></i>
      </a>
    </div>

    <div class="card-body" style="margin-top: 40px;">
      <h3 class="card-title">{{ tarjeta?.nombre }}</h3>

      <!-- Cargo normal -->
      <div *ngIf="!isSportsClub && !tarjeta?.cargo?.includes('[SPORTS_CLUB]')" style="margin-bottom: 1rem;"
        class="text-muted texto-pre" [innerHTML]="tarjeta?.cargo">
      </div>

      <!-- Credencial Deportiva -->
      <div *ngIf="isSportsClub && sportsData" style="margin-bottom: 1rem;" class="text-muted texto-pre">
        <div class="fw-bold">{{ sportsData.cargo }}</div>
        <div *ngIf="sportsData.rut" style="font-size: 0.85rem;">• RUT: {{ sportsData.rut }}</div>
        <div *ngIf="sportsData.fechaNacimiento" style="font-size: 0.85rem;">• F. Nac.: {{ sportsData.fechaNacimiento }}
        </div>
        <div *ngIf="sportsData.institucion" style="font-size: 0.85rem;">• {{ sportsData.institucion }}</div>
      </div>

      <details *ngIf="vehicleDetails.length" class="vehicle-card-details">
        <summary>
          <span>Datos del vehículo</span>
          <i class="fas fa-chevron-down"></i>
        </summary>
        <div class="vehicle-card-grid">
          <div *ngFor="let item of vehicleDetails">
            <small>{{ item.label }}</small>
            <span>{{ item.value }}</span>
          </div>
        </div>
      </details>

      <p class="text-muted" *ngIf="profile?.showAddress">
        <i class="fas fa-map-marker-alt text-danger me-1"></i>
        {{ tarjeta?.direccion }}
      </p>

      <div class="d-flex justify-content-center gap-3">


        <div class="col" style="padding-left: 30px;" *ngIf="profile?.showFooterTienda">
          <a href="https://tarjetasdigitaleschile.cl/sportcard/">
            <img src="/assets/images/banners/shop_button.png" alt="login"
              style="width: 63px; height: 63px; margin-top: -6;" />
          </a>
          <div>
            <span>Tienda</span>
          </div>
        </div>

        <div class="col" style="padding-left: 40px;" *ngIf="profile?.showButtonCall">
          <a [href]="'tel:' + tarjeta?.telefono" class="btn-round"
            [ngStyle]="{'background-color': profile?.buttonColor, 'color': profile?.letterColor}">
            <i class="fas fa-phone"></i>
          </a>
          <div>
            <span>Llamar</span>
          </div>
        </div>

        <div class="col" *ngIf="profile?.showButtonWSP">
          <a [href]="'https://wa.me/' + getCleanWsp(tarjeta?.wsp)" class="btn-round"
            [ngStyle]="{'background-color': profile?.buttonColor, 'color': profile?.letterColor}">
            <i class="fab fa-whatsapp"></i>
          </a>
          <div>
            <span>WhatsApp</span>
          </div>
        </div>

        <div class="col" style="padding-right: 40px;" *ngIf="profile?.showButtonMail">
          <a [href]="'mailto:' + tarjeta?.correo" class="btn-round"
            [ngStyle]="{'background-color': profile?.buttonColor, 'color': profile?.letterColor}">
            <i class="fa-regular fa-envelope"></i>
          </a>
          <div>
            <span>Correo</span>
          </div>
        </div>


      </div>


      <div class="mt-3" *ngIf="profile?.showWSPForm">
        <a (click)="abrirPanel()" class="btn d-block my-2"
          [ngStyle]="{'background-color': profile?.buttonColor, 'color': profile?.letterColor}">
          {{ profile?.textoButtonForm }}
        </a>
      </div>

      <hr *ngIf="profile?.showDivisor">

      <div *ngIf="profile?.showButtonComponent">
        <div class="mt-3">
          <a *ngFor="let btn of profile?.buttons" [href]="btn.link" target="_blank" rel="noopener noreferrer"
            class="btn d-block my-2" [ngStyle]="btn.type === 'full'
                               ? {'background-color': profile?.buttonColor, 'color': profile?.letterColor} 
                               : {'border': '2px solid ' + profile?.buttonColor, 'color': profile?.buttonColor}">
            {{ btn.title }}
          </a>
        </div>
      </div>

      <div *ngIf="profile?.showTexto">
        <div class="text-muted texto-pre" [innerHTML]="profile?.texto"></div>
      </div>


      <div class="social-media-row text-center mt-3" *ngIf="profile?.showRSComponent">
        <ng-container *ngFor="let red of profile?.redes">
          <a [href]="red.link" target="_blank" class="social-icon" [ngStyle]="{'color': profile?.buttonColor}">
            <i [ngClass]="red.iconClass"></i>
          </a>
        </ng-container>
      </div>

      <div class="card-social-media-section" *ngIf="tarjeta?.showRSComponent && tarjeta?.redes?.length">
        <div class="social-media-row text-center mt-3">
          <ng-container *ngFor="let red of tarjeta?.redes">
            <a [href]="red.link" target="_blank" class="social-icon" [ngStyle]="{'color': profile?.buttonColor}">
              <i [ngClass]="red.iconClass"></i>
            </a>
          </ng-container>
        </div>
      </div>



      <div class="d-flex justify-content-center mt-3" *ngIf="profile?.showVideo">
        <iframe class="videoClass" [src]="safeVideoUrl" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
      <div class="d-flex justify-content-center mt-3" *ngIf="profile?.showQR">
        <img id="qr-code" [src]="urlBase + 'qrcode/generate?text=' + tarjeta?.linkProfile" alt="Código QR">
      </div>
    </div>


    <div *ngIf="profile?.showFooter">
      <a [href]="getRedUrl()" target="_blank" rel="noopener noreferrer" class="enlace-usuario">
        <img src="/assets/images/banners/conecta2.png" alt="login" style="width: 100%;" />
      </a>
    </div>


    <div *ngIf="profile?.showFooterTienda">
      <a href="https://tarjetasdigitaleschile.cl/sportcard/" target="_blank" rel="noopener noreferrer"
        class="enlace-usuario">
        <img src="/assets/images/banners/BANNER_TIENDA.png" alt="login" style="width: 100%;" />
      </a>
    </div>

  </div>
</div>

<a *ngIf="tarjeta?.showChatboot && tarjeta?.urlChatboot" class="chatboot-float-btn"
  [href]="tarjeta.urlChatboot" target="_blank" rel="noopener noreferrer"
  [ngStyle]="{'background-color': profile?.buttonColor || '#1d934f', 'color': profile?.letterColor || '#FFFFFF'}"
  aria-label="Abrir chat">
  <i class="fas fa-comments"></i>
  <span class="chatboot-label">Asistente IA</span>
</a>




<!-- Modal background for extra panels -->
<div class="custom-modal-backdrop" *ngIf="panelAbierto || showNotificationsPanel"
  (click)="cerrarPanel(); showNotificationsPanel = false"></div>

<!-- Notifications Panel -->
<div class="custom-modal notifications-panel" *ngIf="showNotificationsPanel">
  <div class="custom-modal-content" style="max-height: 80vh; overflow-y: auto;">
    <div class="custom-modal-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Notificaciones</h5>
      <button class="close-btn btn btn-sm btn-light" (click)="toggleNotificationsPanel()"
        style="font-size: 1.2rem; padding: 0px 8px;">×</button>
    </div>

    <div class="custom-modal-body p-0 mt-3">
      <div *ngIf="notifications.length === 0" class="text-center p-4 text-muted">
        <i class="far fa-bell-slash fa-3x mb-3"></i>
        <p>No tienes notificaciones aún.</p>
      </div>

      <div class="list-group list-group-flush text-start">
        <a *ngFor="let msg of notifications" [href]="msg.url ? msg.url : 'javascript:void(0)'"
          [target]="msg.url ? '_blank' : ''"
          class="list-group-item list-group-item-action d-flex align-items-start border-bottom py-3 position-relative"
          style="text-decoration: none; color: inherit;">

          <!-- Delete button -->
          <button class="btn btn-sm text-muted position-absolute" style="top: 10px; right: 10px; z-index: 10;"
            (click)="deleteNotification($event, msg.id)">
            <i class="fas fa-times"></i>
          </button>

          <ng-container *ngIf="msg.icon">
            <img *ngIf="msg.icon.startsWith('http') || msg.icon.startsWith('assets')" [src]="msg.icon" alt="icon"
              class="rounded-circle me-3" style="width: 40px; height: 40px; object-fit: cover;">
            <div *ngIf="!msg.icon.startsWith('http') && !msg.icon.startsWith('assets')"
              class="rounded-circle bg-light me-3 d-flex align-items-center justify-content-center"
              style="width: 40px; height: 40px;">
              <i [ngClass]="msg.icon" class="fa-lg border-0 bg-transparent"></i>
            </div>
          </ng-container>

          <div *ngIf="!msg.icon"
            class="rounded-circle bg-light me-3 d-flex align-items-center justify-content-center text-primary"
            style="width: 40px; height: 40px;">
            <i class="fas fa-info px-2"></i>
          </div>
          <div class="w-100 pe-4">
            <h6 class="mb-1 fw-bold">{{ msg.title }}</h6>
            <p class="mb-1 small text-muted">{{ msg.body }}</p>
            <small class="text-secondary" style="font-size: 0.7rem;">{{ msg.createdAt | date: 'medium' }}</small>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Modal centrado -->
<div class="custom-modal" *ngIf="panelAbierto">
  <div class="custom-modal-content">
    <div class="custom-modal-header">
      <h5>Envíame tus Datos</h5>
      <button class="close-btn" (click)="cerrarPanel()">×</button>
    </div>

    <div class="custom-modal-body">
      <form (ngSubmit)="enviarDatosExtra()" #extraForm="ngForm">
        <div class="form-group mt-2">
          <label>Nombre</label>
          <input type="text" placeholder="Tu nombre aquí..." class="form-control" required
            [(ngModel)]="formExtra.nombre" name="campo1" #campo1="ngModel"
            [class.is-invalid]="(campo1.invalid && campo1.touched) || (campo1.invalid && extraForm.submitted)">
          <div class="invalid-feedback d-block" *ngIf="(campo1.invalid && campo1.touched) || (campo1.invalid && extraForm.submitted)">
            El nombre es obligatorio.
          </div>
        </div>

        <div class="form-group mt-2">
          <label>Teléfono</label>
          <div class="input-group">
            <input type="text" id="telefono" name="telefono" class="form-control" placeholder="Tu número aquí..."
              maxlength="20" required pattern="^[+0-9\s\-()]{7,20}$" [(ngModel)]="formExtra.telefono"
              #telefono="ngModel"
              [class.is-invalid]="(telefono.invalid && telefono.touched) || (telefono.invalid && extraForm.submitted)" />
          </div>
          <div class="invalid-feedback d-block" *ngIf="(telefono.errors?.['required'] && telefono.touched) || (telefono.errors?.['required'] && extraForm.submitted)">
            El teléfono es obligatorio.
          </div>
          <div class="invalid-feedback d-block" *ngIf="(telefono.errors?.['pattern'] && telefono.touched) || (telefono.errors?.['pattern'] && extraForm.submitted)">
            Ingresa un teléfono válido.
          </div>
        </div>


        <div class="form-group mt-2">
          <label>Correo</label>
          <input type="email" name="correo" #correo="ngModel" placeholder="Tu correo aquí..." class="form-control"
            required [(ngModel)]="formExtra.correo"
            [class.is-invalid]="(correo.invalid && correo.touched) || (correo.invalid && extraForm.submitted)" />
          <div class="invalid-feedback d-block" *ngIf="(correo.errors?.['required'] && correo.touched) || (correo.errors?.['required'] && extraForm.submitted)">
            El correo es obligatorio.
          </div>
          <div class="invalid-feedback d-block" *ngIf="(correo.errors?.['email'] && correo.touched) || (correo.errors?.['email'] && extraForm.submitted)">
            Ingresa un correo válido.
          </div>
        </div>

        <div class="form-group mt-2">
          <label>{{ profile?.textoForm }}</label>
          <input type="text" class="form-control" [(ngModel)]="formExtra.empresa" name="campo4">
        </div>

        <div class="form-group mt-3">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="termsAccepted" [(ngModel)]="termsAccepted"
              name="termsAccepted">
            <label class="form-check-label" for="termsAccepted">
              Acepto los <a href="javascript:void(0)" (click)="showTerms($event)"
                class="text-primary text-decoration-none fw-semibold">Términos y Condiciones</a>
            </label>
          </div>
          <div class="invalid-feedback d-block" *ngIf="extraForm.submitted && termsAccepted !== true">
            Debes aceptar los términos y condiciones para enviar tus datos.
          </div>
        </div>

        <button type="submit" class="btn btn-primary w-100 mt-3" [disabled]="extraForm.invalid || termsAccepted !== true">Enviar</button>
      </form>
    </div>
  </div>
</div>





<div class="modal-backdrop" *ngIf="mostrarModal">
  <div class="modal-contenido">
    <h5>Compartir Tarjeta</h5>
    <p>Puedes compartir tu tarjeta con uno de los siguientes métodos:</p>
    <div class="d-grid gap-2">
      <button class="btn btn-primary" (click)="copiarEnlace()">📋 Copiar enlace</button>
      <a [href]="urlWhatsapp" target="_blank" class="btn btn-success">
        🟢 WhatsApp
      </a>

      <a [href]="urlEmail" class="btn btn-secondary">
        ✉️ Enviar por Email
      </a>

      <hr class="my-2">
      <h6 class="mb-2 mt-1 fw-bold"><i class="fas fa-rocket"></i> AÑADIR A PANTALLA DE INICIO</h6>

      <div class="d-flex justify-content-center gap-2 mb-2">
        <button (click)="showInstruction('android')" class="btn btn-dark btn-sm p-2"
          [ngClass]="{'active': instruction === 'android'}">
          <i class="fab fa-android fa-lg mb-1"></i><br><span style="font-size: 0.7rem;">Android</span>
        </button>
        <button (click)="showInstruction('ios')" class="btn btn-dark btn-sm p-2"
          [ngClass]="{'active': instruction === 'ios'}">
          <i class="fab fa-apple fa-lg mb-1"></i><br><span style="font-size: 0.7rem;">iOS - iPhone</span>
        </button>
        <button (click)="showInstruction('ios')" class="btn btn-dark btn-sm p-2"
          [ngClass]="{'active': instruction === 'ios'}">
          <i class="fab fa-apple fa-lg mb-1"></i><br><span style="font-size: 0.7rem;">iOS - iPad</span>
        </button>
      </div>

      <div *ngIf="instruction === 'android'" class="text-start bg-light p-2 rounded border mb-2">
        <h6 class="fw-bold mb-1"><i class="fab fa-android"></i> Android</h6>
        <p class="small mb-1" style="font-size: 0.85rem;">Para añadir esta tarjeta en tu móvil Android desde el
          navegador web Google Chrome.</p>
        <div class="d-flex align-items-start gap-2 mt-2">
          <i class="fas fa-ellipsis-v fa-lg mt-1 text-muted"></i>
          <p class="small mb-0" style="font-size: 0.8rem;">Pulsa éste botón en la parte superior de la pantalla y
            selecciona la opción <strong>'Añadir a pantalla de inicio'</strong>. Para confirmar, deberás presionar la
            opción <strong>'Añadir'</strong>.</p>
        </div>
      </div>

      <div *ngIf="instruction === 'ios'" class="text-start bg-light p-2 rounded border mb-2">
        <h6 class="fw-bold mb-1"><i class="fab fa-apple"></i> iOS</h6>
        <p class="small mb-1" style="font-size: 0.85rem;">Para añadir esta tarjeta en tu iPhone/iPad desde Safari:</p>
        <div class="d-flex align-items-start gap-2 mt-2">
          <i class="fas fa-share-from-square fa-lg mt-1 text-muted"></i>
          <p class="small mb-0" style="font-size: 0.8rem;">Pulsa el botón <strong>Compartir</strong> en la barra
            inferior y selecciona <strong>'Añadir a la pantalla de inicio'</strong>.</p>
        </div>
      </div>

      <button class="btn btn-outline-dark" (click)="mostrarModal = false">Cerrar</button>
    </div>
  </div>
</div>
